import styled from 'styled-components';

export const StepperContainer = styled.div`
  justify-content: center;
  display: flex;
  margin-top: 40px;
`;
